import Marquee from "react-fast-marquee";

const words = ["Land", "Luxury", "Growth", "Protection", "Legacy"];

export const EditorialMarquee = () => (
  <section className="py-16 md:py-24 border-y border-white/5 overflow-hidden" data-testid="editorial-marquee" aria-hidden="true">
    <Marquee speed={28} gradient={false} pauseOnHover>
      <div className="flex items-baseline">
        <span className="font-display italic text-4xl md:text-6xl text-[#8A8D98] whitespace-nowrap pr-16">
          A curated approach to real assets and private wealth
        </span>
        {words.map((w) => (
          <span key={w} className="flex items-baseline pr-16">
            <span className="font-display text-4xl md:text-6xl text-outline uppercase tracking-wide whitespace-nowrap">{w}</span>
            <span className="text-[#C8A97E] text-2xl md:text-4xl pl-16">·</span>
          </span>
        ))}
      </div>
    </Marquee>
  </section>
);
